// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"20d88843","358":"02f839e1","491":"800dc222","594":"9bf6aef6"}[chunkId] + ".chunk.js";
};